import React, { useState, useRef, useMemo, useCallback, useContext } from 'react';
import { AgGridReact, CustomCellRendererProps } from 'ag-grid-react'; // the AG Grid React Component

import 'ag-grid-community/styles/ag-grid.css'; // Core grid CSS, always needed
import 'ag-grid-community/styles/ag-theme-alpine.css'; // Optional theme CSS
import moment from 'moment';
import { CellClickedEvent, ColDef, GridReadyEvent, GridSizeChangedEvent, ValueFormatterParams } from 'ag-grid-community';
import { useNavigate } from 'react-router-dom';
import { DependencyInjectionContext } from '../../../../contexts/dependency-injection-context';
import { SetSubmissionViewedRequest } from '../../../../common';

const FormSubmissionsList = ({ submissions, clientId }: {
  submissions: any,
  clientId: string | undefined
}) => {

  const gridRef = useRef<any>();
  const navigate = useNavigate();
  const { formsApi } = useContext(DependencyInjectionContext);

  const [columnDefs, setColumnDefs] = useState<ColDef[]>([
    // {
    //   field: 'id',
    //   cellRenderer: (params: CustomCellRendererProps) => unreadCellRenderer(params),
    // },
    {
      field: 'formName',
      cellRenderer: (params: CustomCellRendererProps) => unreadCellRenderer(params),
    },
    {
      field: 'createdOn',
      headerName: 'Submission Date & Time',
      cellRenderer: (params: CustomCellRendererProps) => unreadCellRenderer(params),
      valueFormatter: (params: ValueFormatterParams) => moment(params.value).format("YYYY-MM-DD HH:mm:ss")
    },
    {
      field: 'ipAddress',
      headerName: 'IP Address',
      cellRenderer: (params: CustomCellRendererProps) => unreadCellRenderer(params),
    }
    // { field: 'isViewed' }
  ]);

  const unreadCellRenderer = (params: CustomCellRendererProps) => {
    const value = params.valueFormatted ? params.valueFormatted : params.value;
    if (params.data.isViewed) {
      return <>{value}</>;
    }
    else {
      return <strong>{value}</strong>
    }
  };

  // DefaultColDef sets props common to all Columns
  const defaultColDef = useMemo(() => ({
    sortable: true
  }), []);

  // Example of consuming Grid Event
  const cellClickedListener = useCallback((event: CellClickedEvent) => {
    navigate(`/forms/submissions/${event.data.id}`);
    const request: SetSubmissionViewedRequest = {
      isViewed: true,
      submissionId: event.data.id
    };

    formsApi.post("/SetSubmissionViewed", request);
  }, []);

  const onGridSizeChanged = useCallback((params: GridSizeChangedEvent) => {
    gridRef.current.api.sizeColumnsToFit();
    const columns = gridRef.current.api.getAllGridColumns();
    const lastColumn = columns[columns.length - 1];
    gridRef.current.api.setColumnWidth(lastColumn.colId, lastColumn.actualWidth - 1);
  }, []);

  const onRowDataUpdated = useCallback((event: any) => {
    gridRef.current.api.applyColumnState({
      state: [
        { colId: "isViewed", sort: "desc" },
        { colId: "createdOn", sort: "desc" },
      ],
      defaultState: { sort: null },
    });
  }, []);

  return (
    <div className="ag-theme-alpine" style={{ width: "100%", height: "100%", minHeight: "300px" }}>

      <AgGridReact
        ref={gridRef} // Ref for accessing Grid's API

        rowData={submissions} // Row Data for Rows

        columnDefs={columnDefs} // Column Defs for Columns
        defaultColDef={defaultColDef} // Default Column Properties

        animateRows={true} // Optional - set to 'true' to have rows animate when sorted
        rowSelection='single' // Options - allows click selection of rows
        suppressRowClickSelection={true}

        pagination={true}
        paginationAutoPageSize={true}

        onCellClicked={cellClickedListener} // Optional - registering for Grid Event
        onGridSizeChanged={onGridSizeChanged}
        onRowDataUpdated={onRowDataUpdated}
      />
    </div>
  );
};

export default FormSubmissionsList;
